import { createIcon } from '../createIcon';
import { ReactComponent as IconCog } from '../svg/cog.svg';

export default createIcon(IconCog);
